import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import { Overview } from './components/overview';

const GMDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Dashboard', path: '.' }]));
  }, [dispatch]);

  return (
    <PageContentWrapper>
      <Overview />
    </PageContentWrapper>
  );
};

export default GMDashboard;
